export const SERVICE_UNAVAILABLE_TITLE = '現在ご利用できないサービスです';
export const SERVICE_UNAVAILABLE_BUTTON_TEXT = '会員証トップへ';
